import _ from 'lodash';

/**
 * Represents a state object that can be either a record (object) or an array of records
 */
type State = Record<string, unknown> | Record<string, unknown>[];

/**
 * Immutably sets a value at a specified path within a state object.
 * 
 * This utility function creates a shallow clone of the state and sets a value
 * at the specified path using lodash's setWith method. The function ensures
 * immutability by cloning the original state before modification.
 * 
 * @param state - The original state object or array to modify
 * @param name - The path where to set the value (supports dot notation and array indices)
 * @param value - The value to set at the specified path
 * @returns A new state object with the value set at the specified path
 */
const setIn = (state: State, name: string, value: unknown): State => {
	// Use lodash's setWith to set the value at the specified path
	// _.clone creates a shallow copy to maintain immutability
	return _.setWith(_.clone(state), name, value);
};

export default setIn;
